<script>
  import { Link } from 'svelte-navigator'
  import fetchO from '../../oauth.js'

  // Fetch all body parts for the filter bar
  let fetchBodyParts = (async () => {
    const response = await fetchO('/bodyparts/')
    return await response.json()
  })()

  // We need to fetch all exercises (even when filtering) to have the total number of exercises available for the left filter bar.
  let fetchAllExercises = (async () => {
    const response = await fetchO('/exercises/')
    return await response.json()
  })()

  // Fetch the Exercises that train a certain bodypart by filtering on the server side
  let filter_trained_bodypart = undefined
  let url
  $: {
    url = '/exercises/?'

    if (filter_trained_bodypart != undefined) {
      url += 'trained_bodyparts=' + filter_trained_bodypart.id
    }
  }

  $: fetchExercises = (async () => {
    const response = await fetchO(url)
    return await response.json()
  })()

  // Updates the reactive variable which rerenders the right parts of this page
  function filterBodyPart(bp) {
    filter_trained_bodypart = bp
  }
</script>

<div class="row">
  <div class="col-sm-4 col-lg-3 col-xl-2 pb-2">
    <!-- Filter Bar -->
    <div class="d-sm-none d-flex align-items-center">
      <h1 class="me-auto">Exercises</h1>
      <button
        class="btn btn-sm btn-secondary"
        id="filterbutton"
        type="button"
        aria-expanded="false"
        data-bs-toggle="collapse"
        data-bs-target="#filterbar"
      >
        <i class="bi bi-filter-circle " /><i class="bi bi-filter-circle-fill" />
        Filter Exercises
      </button>
    </div>

    <div id="filterbar" class="collapse d-sm-block">
      <h5><span class="d-sm-none">Filter by</span> Trained Bodyparts</h5>
      {#await Promise.all([fetchBodyParts, fetchAllExercises])}
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      {:then data}
        <div class="list-group">
          {#each data[0].results as bp}
            <button
              class="list-group-item d-flex justify-content-between align-items-center list-group-item-action"
              class:active={filter_trained_bodypart &&
                filter_trained_bodypart.id == bp.id}
              on:click={() => filterBodyPart(bp)}
            >
              {bp.name}
              <span class="badge bg-secondary rounded-pill"
                >{bp.exercises_count}</span
              >
            </button>
          {/each}
          <button
            class="list-group-item d-flex justify-content-between align-items-center list-group-item-action"
            class:active={!filter_trained_bodypart}
            on:click={() => filterBodyPart(undefined)}
            >Any
            <span class="badge bg-secondary rounded-pill">{data[1].count}</span>
          </button>
        </div>
      {:catch error}
        <p>An error occurred {error}!</p>
      {/await}
    </div>
  </div>
  <div class="col-sm-8 col-lg-9 col-xl-10">
    <div class="row g-3">
      {#await fetchExercises}
        <div class="col d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      {:then data}
        {#each data.results as exercise}
          <div class="col-sm-12 col-md-6 col-xl-4">
            <div class="card h-100 shadow-sm">
              {#if exercise.steps.length > 0 && exercise.steps[0].image}
                <img
                  src={exercise.steps[0].image.medium}
                  alt="Exercise {exercise.name} First Step"
                  class="card-img-top"
                />
              {/if}
              <div class="card-body">
                <h5 class="card-title">{exercise.name}</h5>
                <p class="card-text">
                  Trained Bodyparts:
                  {#each exercise.trained_bodyparts as bp}
                    <a
                      class="badge rounded-pill bg-primary"
                      role="button"
                      href={'#'}
                      on:click|preventDefault={() => filterBodyPart(bp)}
                      >{bp.name}</a
                    >
                  {/each}
                </p>
                {#if exercise.required_equipment.length > 0}
                  <p class="card-text">
                    Required Equipment:
                    {#each exercise.required_equipment as equipment}
                      <span class="badge rounded-pill bg-light text-dark"
                        >{equipment.name}</span
                      >
                    {/each}
                  </p>
                {/if}
              </div>
              <div class="card-footer">
                <Link
                  to="details/{exercise.id}"
                  class="btn btn-primary"
                  role="button">Details</Link
                >
              </div>
            </div>
          </div>
        {/each}
      {:catch error}
        <p>An error occurred {error}!</p>
      {/await}
    </div>
  </div>
</div>

<svelte:head>
  <title>Fich Exercises</title>
</svelte:head>

<style>
  a.badge {
    text-decoration: none;
  }
  a.badge:hover {
    color: white;
  }

  #filterbutton:global([aria-expanded='true']) .bi-filter-circle {
    display: none;
  }
  #filterbutton:global([aria-expanded='false']) .bi-filter-circle-fill {
    display: none;
  }
</style>
